import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CaretLeftFill } from 'react-bootstrap-icons';

const BackButton = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Button variant="outline-primary" type="button" className="m-10" onClick={() => navigate(-1)}>
      <CaretLeftFill className="button-left-icon" />
      戻る
    </Button>
  );
};

export default BackButton;
